import { configureStore } from '@reduxjs/toolkit';
import { analyticsApi } from './analyticsApi';
import { reviewsApi } from './reviewsApi';
import analyticsReducer from './analyticsSlice';
import analyticsCacheReducer from './analyticsCacheSlice';

export const store = configureStore({
  reducer: {
    analytics: analyticsReducer,
    analyticsCache: analyticsCacheReducer,
    [analyticsApi.reducerPath]: analyticsApi.reducer,
    [reviewsApi.reducerPath]: reviewsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(analyticsApi.middleware, reviewsApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;